export default "__VITE_ASSET__CGzsjUuf__"